import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { activityTypeData } from '@isophi/core-ui';
import { ManagerActivity } from '@isophi/mng-api';

@Component({
  selector: 'app-pap-portfolio-row',
  templateUrl: './pap-portfolio-row.component.html',
  styleUrls: ['./pap-portfolio-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PapPortfolioRowComponent {
  @Input() portfolioActivity: ManagerActivity;

  activityTypeData = activityTypeData;
}
